import { render, staticRenderFns } from "./catvsdog.vue?vue&type=template&id=ebeb03e2&scoped=true&"
import script from "./catvsdog.vue?vue&type=script&lang=js&"
export * from "./catvsdog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeb03e2",
  null
  
)

export default component.exports